<ejs-dialog
	#modal
	(close)="closeModal()"
	cssClass="modal-lg"
	[attr.data-test-id]="'addGuestInformationModal'">
	<ng-template #header>
		<div class="dlg-template">Add Guest Information</div>
	</ng-template>
	<ng-template #content>
		<form
			  [formGroup]="formGroup"
			  (ngSubmit)="createGuestInvoice()"
			  #templateForm="ngForm">
			@if (formGroup.invalid && templateForm.submitted) {
				<gandalf-lib-validation-messages
					[form]="formGroup"
					[requestObj]="request"
					[attr.data-test-id]="'addGuestInformationModalValidationMessage'">
				</gandalf-lib-validation-messages>
			}
			<div class="card-body">
				<div class="row">
					<div class="col-lg-7 col-xl-5">
						<div class="row mb-3">
							<label for="name" class="col-md-4 col-lg-3 col-form-label">Name</label>
							<div class="col-md-8 col-lg-9">
								<input id="name" type="text" class="e-input" revFocusInput formControlName="name"/>
							</div>
						</div>
						<div class="row mb-3">
							<label class="col-md-4 col-lg-3 col-form-label">Phone</label>
							<div class="col-md-8 col-lg-9">
								<pms-phone-number-input formControlName="phoneNumber"></pms-phone-number-input>
							</div>
						</div>
						<div class="row mb-3">
							<label for="email" class="col-md-4 col-lg-3 col-form-label">Email</label>
							<div class="col-md-8 col-lg-9">
								<input id="email" type="text" class="e-input" formControlName="email"/>
							</div>
						</div>
					</div>
					<div class="col-lg-7 col-xl-5" [attr.data-test-id]="'addGuestInformationModalAddressFormGroup'">
						<pms-address-form [parentFormGroup]="formGroup" [isCreating]="true" [autoselectStateProvince]="false"
										  class="form-layout-col-md-4-8-md-3-9"></pms-address-form>
					</div>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template #footerTemplate>
		<button ejs-button iconCss="fa fa-times" type="button" (click)="closeModal()" [attr.data-test-id]="'addGuestInformationCancelButton'">Cancel</button>
		<button ejs-button [isPrimary]="true" type="submit" (click)="submitForm($event)" [attr.data-test-id]="'addGuestInformationSaveButton'">Save</button>
	</ng-template>
</ejs-dialog>
